import { startTest, submitAnswer, submitTest, reportViolation } from '../../shared/services/apiService';

// ── Start or resume a test session ───────────────────────────────────────────
export const loadTestSession = async () => {
  const res     = await startTest();
  const payload = res.data.data;

  const restoredAnswers = {};
  (payload.savedAnswers || []).forEach(a => {
    if (a.selected_option) restoredAnswers[a.question_id] = a.selected_option;
  });

  return { payload, restoredAnswers };
};

// ── Save a single answer ──────────────────────────────────────────────────────
export const saveAnswer = async (sessionId, questionId, selectedOption) => {
  await submitAnswer({ sessionId, questionId, selectedOption });
};

// ── Final submission ──────────────────────────────────────────────────────────
export const finalizeTest = async (sessionId) => {
  const res = await submitTest({ sessionId });
  return res.data.data.result;
};

// ── Report an anti-cheat violation ───────────────────────────────────────────
export const sendViolation = async (sessionId, violationType, details) => {
  const res = await reportViolation({ sessionId, violationType, details });
  return res.data.data;
};
